import { LockClosedIcon } from '@heroicons/react/24/outline'
import { ReactNode } from 'react'
import { classNames } from '../../_helpers'
import { LABEL_CLASS } from './styles'

type PropType = {
  label: string;
  small?: boolean;
  children: ReactNode,
  isRequired?: boolean
  isPrivate?: boolean
  labelPadding?: boolean
}

export const Fieldgroup = ({ isPrivate, label, children, small }: PropType) => {
  return (
    <div role="group">
      <div className={classNames(LABEL_CLASS, 'mb-2', small ? 'text-xs' : 'text-sm')}>
        {isPrivate && (
          <LockClosedIcon className={'w-4 h-4 mr-2 shrink-0'} />
        )}
        {label}
      </div>
      <div className="max-w-xl space-y-3">
        {children}
      </div>
    </div>
  )
}
